import { useTranslation } from 'react-i18next';
import { useTheme } from '../../lib/ThemeContext';
import { cn } from '../../lib/cn';

export default function ThemeToggle({ className }) {
  const { t } = useTranslation();
  const { dark, toggle } = useTheme();

  return (
    <button
      onClick={toggle}
      className={cn(
        'p-2 rounded-lg transition-colors duration-200',
        'text-gray-500 hover:text-gray-900 hover:bg-gray-100',
        'dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700',
        'focus:outline-none focus:ring-2 focus:ring-gray-300 dark:focus:ring-gray-600',
        className
      )}
      aria-label={dark ? t('ui.switchToLight') : t('ui.switchToDark')}
      title={dark ? t('ui.switchToLight') : t('ui.switchToDark')}
    >
      {dark ? (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
          />
        </svg>
      ) : (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
          />
        </svg>
      )}
    </button>
  );
}
